export default class AlertsController {
  constructor (AlertsService) {
    'ngInject'

    this.alerts = AlertsService.alerts
    this.close = AlertsService.close
  }
}
